import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import "react-medium-image-zoom/dist/styles.css";
import { useHistory, useParams } from "react-router";
import { toast } from "react-toastify";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, Row } from "../../components/Component";
import { GET, POST } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  EXTERNAL_PORT_FEE_CATEGORY_ID,
  INGREDIENT_CATEGORY_ID,
  renderLabelIngredientPriceHistoryOption,

  REQUEST_UPDATE_STATUS
} from "../../utils/Utils";

import { Loading } from '../../components/Component';
import { getDefaultBill } from "../../utils/Utils";
import BillOtherCreateForm from "../billOtherManager/BillOtherCreateForm";
import BillExternalPortFeeCreateForm from "../externalportfeemanager/BillExternalPortFeeCreateForm";
import CreateBillForm from "./billcreatecomponent/CreateBillForm";

const BillPreviewUpdate = () => {
  const history = useHistory();
  const params = useParams();
  const id = params.id;

  const methodForm = useForm({
    defaultValues: {
      ...getDefaultBill()
    },
    shouldFocusError: true,
  });
  const { reset, register, errors } = methodForm;


  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);

  const [data, setData] = useState();
  const [ingredientPriceHistoryOptions, setIngredientPriceHistoryOptions] = useState([]);
  const [haveRequestUpdate, setHaveRequestUpdate] = useState(null);

  useEffect(() => {
    if (data) {
      if (data.ingredientPriceHistoryId) {
        setIngredientPriceHistoryOptions([
          {
            label: renderLabelIngredientPriceHistoryOption(data.ingredientPriceHistory),
            value: data.ingredientPriceHistoryId,
            data: data.ingredientPriceHistory,
          },
        ]);
      }
    }
  }, [data]);

  useEffect(() => {

    if (id) {
      GET(`/bill/${id}`, {}, true).then((resp) => {
        let {
          data: { haveRequestUpdate, ...data },
        } = resp;
        if (REQUEST_UPDATE_STATUS.REQUESTING !== haveRequestUpdate?.status) {
          return history.goBack()
        }
        setHaveRequestUpdate(haveRequestUpdate)
        data = {
          ...data,
          ...haveRequestUpdate.data,
          reason: haveRequestUpdate.reason,
        };
        setData(data);
        reset({
          ...data,
          createdAt: moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
        });
      });
    }
  }, [params]);

  const actionRequestUpdate = (status) => {
    setLoading(true);
    POST(
      `/bill/action-request-update/${id}`,
      {
        status,
      },
      {},
      true
    )
      .then((res) => {
        toast.success("Cập nhật thành công");
        history.goBack();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  if (!data) {
    return <Loading />
  }

  return (
    <React.Fragment>
      <Head title="Đơn hàng"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div id="DataTables_Table_1_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                <div className="my-3">
                  <FormProvider {...methodForm}>
                    {
                      !!EXTERNAL_PORT_FEE_CATEGORY_ID[data.categoryId]
                        ? <BillExternalPortFeeCreateForm
                          disabledForm={true}
                          id={id}
                          duplicateId={null}
                          billData={data}
                          ingredientPriceHistoryOptions={ingredientPriceHistoryOptions}
                          setLoading={setLoading}
                        />
                        : !!INGREDIENT_CATEGORY_ID[data.categoryId]
                          ? <CreateBillForm
                            disabledForm={true}
                            id={id}
                            duplicateId={null}
                            billData={data}
                            ingredientPriceHistoryOptions={ingredientPriceHistoryOptions}
                            setLoading={setLoading}
                          />
                          : <BillOtherCreateForm
                            disabledForm={true}
                            id={id}
                            duplicateId={null}
                            billData={data}
                            ingredientPriceHistoryOptions={ingredientPriceHistoryOptions}
                            setLoading={setLoading}
                          />
                    }

                    <Row>

                      <Col size="12" className="position-relative">
                        <div className="form-overlay"></div>
                        <div className="form-group">
                          <label className="form-label" >
                            Lý do cập nhật<span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <textarea
                              rows={3}
                              className="form-control"
                              style={{ height: "unset" }}
                              name="reason"
                              ref={register({
                                required: "Vui lòng nhập thông tin",
                              })}
                            />
                            <ErrorMessage errors={errors} name="reason" render={({ message }) => <span className="invalid">{message}</span>} />
                          </div>
                        </div>
                      </Col>
                      {haveRequestUpdate ? (
                        <Col size="12" >
                          <div className="form-group">
                            <label className="form-label" >
                              Chức năng duyệt đơn cho quản lý:
                            </label>
                            <div className="form-control-wrap mt-2">
                              <Button color="primary" type="button" className={"mr-2"} onClick={() => actionRequestUpdate(REQUEST_UPDATE_STATUS.APPROVED)}>
                                <span>Chấp nhận</span>
                              </Button>
                              <Button color="primary" type="button" className={"mr-2"} onClick={() => actionRequestUpdate(REQUEST_UPDATE_STATUS.REJECTED)}>
                                <span>Từ chối</span>
                              </Button>
                            </div>
                          </div>
                        </Col>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default BillPreviewUpdate;
